/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Switch, Typography } from "@mui/material";
import DatePicker from "react-flatpickr";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { v4 as uuidV4 } from "uuid";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import SoftTypography from "components/SoftTypography";

const tableStyle = {
  borderCollapse: "collapse",

  fontSize: 13,
};
const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  whiteSpace: "wrap",
};
const selectStyle = {
  minWidth: 200,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",

  borderRadius: "0.5rem",
};
const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};
const dataTable = [
  {
    id: uuidV4(),
    stt: "1",
    asset: "Doanh thu bán hàng và cung cấp dịch vụ",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "",
    asset: "Trong đó: - Doanh thu bán hàng hóa, dịch vụ xuất khẩu",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "2",
    asset: "Các khoản giảm trừ doanh thu",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "3",
    asset: "Doanh thu thuần về bán hàng và cung cấp dịch vụ",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "4",
    asset: "Giá vốn hàng bán",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "5",
    asset: "Lợi nhuận gộp về bán hàng và cung cấp dịch vụ",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "6",
    asset: "Chi phí bán hàng",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "7",
    asset: "Chi phí quản lý doanh nghiệp",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "8",
    asset: "Doanh thu hoạt động tài chính",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "8.1",
    asset: "Trong đó: Lãi tiền gửi và lãi cho vay",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9",
    asset: "Chi phí tài chính",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9.1",
    asset: "Trong đó: - Chi phí lãi tiền vay",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9.1.a",
    asset: "Chi phí lãi vay được trừ trong kỳ",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "9.1.b",
    asset:
      "Phần chi phí lãi vay trong kỳ không được trừ chuyển sang kỳ sau theo quy định tại điểm b khoản 3 Điều 16",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "10",
    asset: "Chi phí khấu hao phát sinh trong kỳ",
    readOnly: false,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "11",
    asset: "Lợi nhuận thuần từ hoạt động sản xuất kinh doanh trong kỳ (11)=(5)-(6)-(7)+(8)-(9)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "12",
    asset:
      "Lợi nhuận thuần từ hoạt động sản xuất kinh doanh trong kỳ không bao gồm chênh lệch doanh thu và chi phí của hoạt động tài chính (12)=(11)-(8)+(9)",
    readOnly: true,
    value: {
      value3: { value: 0, readOnly: true },
      value4: { value: 0, readOnly: true },
      value5: { value: 0, readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "13",
    asset:
      "Tổng lợi nhuận thuần từ hoạt động kinh doanh cộng chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay trong kỳ cộng chi phí khấu hao trong kỳ (14)=[(9.1)-(8.1)]/(13)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "14",
    asset:
      "Tỷ lệ chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay phát sinh trong kỳ trên tổng lợi nhuận thuần từ hoạt động kinh doanh cộng chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay trong kỳ cộng chi phí khấu hao trong kỳ (14)=[(9.1)-(8.1)]/(13)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: true },
      value4: { value: "", readOnly: true },
      value5: { value: "", readOnly: true },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15",
    asset:
      "Chi phí lãi vay của các kỳ trước chuyển sang, trong đó: (15)=(15.1)+(15.2)+(15.3)+(15.4)+(15.5)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "15.1",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-1) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15.2",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-2) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15.3",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-3) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15.4",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-4) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "15.5",
    asset: "- Phần chi phí lãi vay không được trừ từ năm (n-5) chuyển sang kỳ tính thuế (n)",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: false },
    },
  },
  {
    id: uuidV4(),
    stt: "16",
    asset:
      "Tỷ lệ chi phí lãi vay sau khi trừ lãi tiền gửi và lãi cho vay phát sinh cộng chi phí lãi vay của các kỳ trước chuyển sang trên tổng lợi nhuận thuần từ hoạt động kinh doanh cộng chi phí lãi vay (sau khi trừ lãi tiền gửi và lãi cho vay) trong kỳ cộng chi phí khấu hao trong kỳ (16)=[(9.1)-(8.1)+(15)]/[13]",
    readOnly: false,
    value: {
      value3: { value: 0, readOnly: false },
      value4: { value: 0, readOnly: false },
      value5: { value: 0, readOnly: false },
      value6: { value: 0, readOnly: true },
    },
  },
  {
    id: uuidV4(),
    stt: "17",
    asset: "Tỷ suất lợi nhuận sử dụng xác định giá giao dịch liên kết (%)",
    readOnly: true,
    value: {
      value3: { value: "", readOnly: false },
      value4: { value: "", readOnly: false },
      value5: { value: "", readOnly: false },
      value6: { value: "", readOnly: true },
    },
  },
];
const stt = [
  "a",
  "b",
  "c",
  "d",
  "đ",
  "e",
  "g",
  "h",
  "i",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "x",
  "y",
];
export default function TableGDLK01d({ formData, setFieldValue }) {
  const [data1, setData1] = useState(false);
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  useEffect(() => {
    console.log(data1);
  }, [data1]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  // 1.2.abc
  const [data2, setData2] = useState([
    {
      id: uuidV4(),
      content: "",
      value3: 0,
      value4: 0,
      value5: "",
      value6: 0,
    },
  ]);
  useEffect(() => {
    setFieldValue("valuesTable2", data2);
  }, [data2]);
  const handleChange2 = (values) => {
    const { id, name, value, type } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
    console.log({ id, name, value, type, data2 });
  };
  const handleChangeDate2 = (date, id) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, date };
        }
        return item;
      })
    );
  };
  const handleChangeSelect2 = (id, name, value) => {
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };
  const handleAdd2 = () => {
    setData2((prev) => [
      ...prev,
      {
        id: uuidV4(),
        content: "",
        value3: 0,
        value4: 0,
        value5: 0,
        value6: "",
        value7: 0,
        value8: 0,
        value9: 0,
        value10: "",
        value11: 0,
        value12a: 0,
        value12b: 0,
        value12c: 0,
        value12d: 0,
        value13: false,
      },
    ]);
  };
  const handleDelete2 = (id) => {
    setData2((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">
          MỤC IV. KẾT QUẢ SẢN XUẤT KINH DOANH SAU KHI XÁC ĐỊNH GIÁ GIAO DỊCH LIÊN KẾT
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-start">
        <Typography variant="h6">
          1. Dành cho người nộp thuế thuộc các ngành sản xuất, thương mại, dịch vụ
        </Typography>
      </Box>
      <Box>
        <table style={{ ...tableStyle, marginBottom: 50, marginTop: 50 }}>
          <tbody>
            <tr>
              <Td
                style={{
                  textAlign: "left",
                  fontWeight: 400,
                }}
              >
                Người nộp thuế đã ký thỏa thuận trước về phương pháp xác định giá thuế (APA)
              </Td>
              <Td
                style={{
                  textAlign: "center",
                  maxWidth: 100,
                }}
              >
                <Switch checked={data1} onChange={({ target: { checked } }) => setData1(checked)} />
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={2} style={{ textAlign: "center", width: 10 }}>
                STT
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", minWidth: 200 }}>
                Giá trị giao dịch liên kết
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Giá trị giao dịch với các bên độc lập
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", minWidth: 400 }}>
                Tổng giá trị phát sinh từ hoạt động kinh doanh trong kỳ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định theo Hồ sơ xác định giá giao dịch liên kết
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Giá trị xác định giá theo APA
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center" }}>(1)</Td>
              <Td style={{ textAlign: "center" }}>(2)</Td>
              <Td style={{ textAlign: "center" }}>(3)</Td>
              <Td style={{ textAlign: "center" }}>(4)</Td>
              <Td style={{ textAlign: "center" }}>(5)</Td>
              <Td style={{ textAlign: "center" }}>(6) = (3) + (4) + (5)</Td>
            </tr>
            {data &&
              data.length > 0 &&
              data.map((rows, index) => (
                <tr key={index}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value3.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value3.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value3.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value3"
                        value={rows.value.value3.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value4.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value4.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value4.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value4"
                        value={rows.value.value4.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value5.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value5.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value5.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value5"
                        value={rows.value.value5.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    style={{
                      background:
                        rows.readOnly === true
                          ? "#ddeff3"
                          : rows.value.value6.readOnly === true
                          ? "#ddeff3"
                          : "transparent",
                    }}
                  >
                    {rows.value.value6.value !== "" && (
                      <InputTable
                        readOnlyBackground={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        readOnly={
                          rows.readOnly === true
                            ? true
                            : rows.value.value6.readOnly === true
                            ? true
                            : false
                        }
                        id={rows.id}
                        name="value6"
                        value={rows.value.value6.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}
            {data2.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center" }}>
                  {stt[index] || "y"}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete2(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="content"
                    value={item.content}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange2}
                  />
                </Td>
                <Td>
                  <InputTable
                    id={item.id}
                    name="value4"
                    value={item.value4}
                    onChange={handleChange2}
                  />
                </Td>
                <Td style={{ background: "#ddeff3" }}></Td>
                <Td style={{ background: "#ddeff3" }}>
                  <InputTable
                    readOnly={true}
                    readOnlyBackground={true}
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange2}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd2}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, readOnlyBackground, fontWeight, type = "text", ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "number") {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text" && name !== "number") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      style={{
        textAlign: "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: readOnlyBackground === true ? "#ddeff3" : "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        minWidth: 180,
        borderRadius: "0.5rem",
        fontWeight: fontWeight,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
